import React from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";
import MoonLogo from "assets/img/brand/MMCP_LOGO.png";
import { Image } from "@chakra-ui/react";

export function SidebarBrand() {
  //   Chakra color mode

  return (
    <Flex align='center' direction='column'>
      <Image src={MoonLogo} alt='Moon Mission Control Panel Logo' width='75%' mb='20px'/>
      <HSeparator width='80%' mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
